<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
          color="primary"
          v-on="on"
          v-bind="attrs"
          v-if="hasAnalytics"
          dark
          @click="openAnalytics"
          :aria-label="$t('course.seeAnalytics')"
      >
        mdi-chart-pie
      </v-icon>
    </template>
    <span>{{ $t('course.seeAnalytics') }}</span>
  </v-tooltip>
</template>

<script>
  import {mapGetters} from "vuex"

  export default {
    name: "AnalyticsButton",
    props: {
      hasAnalytics: { type: Boolean, required: true },
      courseId: { type: Number, required: true }
    },
    computed: {
      ...mapGetters(['linksInNewTab'])
    },
    methods: {
      openAnalytics: function () {
        const BASE_URL = process.env.VUE_APP_ANALYTICS_SERVER
        const url = BASE_URL.replace('{course_id}', this.courseId)
        if (this.linksInNewTab) {
          window.open(url)
        } else {
          window.location = url
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .v-icon{
    height: 24px;
  }
</style>
